define('contentDetailRowView',['contentDetailView', 'contentDetailRowViewConfig'], function(contentDetailView, contentDetailRowViewConfig) {

    'use strict';

    return contentDetailView.extend({
        defaultOptions : contentDetailRowViewConfig
    });
});

